"use client";

import { Home } from "@/components/pages/auth";
import GoogleAd from "@/components/shared/GoogleAd";

export function HomeView() {
  return (
    <div>
      <Home />
      <div className="max-w-[1280px] mx-auto px-4 py-8">
        <GoogleAd
          adSlot={process.env.NEXT_PUBLIC_AD_SLOT_BANNER || ""}
          adFormat="horizontal"
          fullWidthResponsive={true}
          className="w-full"
        />
      </div>
    </div>
  );
}
